<pgh-modal-window>
  <div modal-close>
    <button mat-icon-button class="close-button mat-icon-button" sf-aria-label="Global_Close_Window" matDialogClose>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div modal-title style="text-align: left;font-size:24px;font-weight:600;">
    <adp-label labelKey="Global_Modal_CellularEnabled_Info_Header"></adp-label>
  </div>
  <div modal-body class="mt-30 mb-30" style="color:#3D515A;">
    <div><adp-label labelKey="Global_Modal_CellularEnabled_Info_Subheader"></adp-label></div>
    <div class="mat-table">
      <div class="mat-header-row" style="text-align: center;">
        <div class="mat-header-cell"></div>
        <div class="mat-header-cell"><adp-label labelKey="Global_Modal_CellularEnabled_Info_Column1"></adp-label></div>
        <div class="mat-header-cell"><adp-label labelKey="Global_Modal_CellularEnabled_Info_Column2"></adp-label></div>
      </div>
      <div class="mat-row">
        <div class="mat-cell"><adp-label labelKey="Global_Modal_CellularEnabled_Info_Row1"></adp-label></div>
        <div class="mat-cell" style="text-align:center;overflow:visible !important;"><mat-icon style="height:24px;width:24px;overflow:visible !important;"><ng-container *ngTemplateOutlet="checkCircleIcon">
        </ng-container></mat-icon></div>
        <div class="mat-cell" style="text-align:center;overflow:visible !important;"><mat-icon style="height:24px;width:24px;overflow:visible !important;"><ng-container *ngTemplateOutlet="minusIcon">
        </ng-container></mat-icon></div>
      </div>
      <div class="mat-row">
        <div class="mat-cell"><adp-label labelKey="Global_Modal_CellularEnabled_Info_Row2"></adp-label></div>
        <div class="mat-cell" style="text-align:center;overflow:visible !important;"><mat-icon style="height:24px;width:24px;overflow:visible !important;"><ng-container *ngTemplateOutlet="checkCircleIcon">
        </ng-container></mat-icon></div>
        <div class="mat-cell" style="text-align:center;overflow:visible !important;"><mat-icon style="height:24px;width:24px;overflow:visible !important;"><ng-container *ngTemplateOutlet="minusIcon">
        </ng-container></mat-icon></div>
      </div>
      <div class="mat-row">
        <div class="mat-cell"><adp-label labelKey="Global_Modal_CellularEnabled_Info_Row3"></adp-label></div>
        <div class="mat-cell" style="text-align:center;overflow:visible !important;"><mat-icon style="height:24px;width:24px;overflow:visible !important;"><ng-container *ngTemplateOutlet="checkCircleIcon">
        </ng-container></mat-icon></div>
        <div class="mat-cell" style="text-align:center;overflow:visible !important;"><mat-icon style="height:24px;width:24px;overflow:visible !important;"><ng-container *ngTemplateOutlet="minusIcon">
        </ng-container></mat-icon></div>
      </div>
      <div class="mat-row">
        <div class="mat-cell"><adp-label labelKey="Global_Modal_CellularEnabled_Info_Row4"></adp-label></div>
        <div class="mat-cell" style="text-align:center;overflow:visible !important;"><mat-icon style="height:24px;width:24px;overflow:visible !important;"><ng-container *ngTemplateOutlet="checkCircleIcon">
        </ng-container></mat-icon></div>
        <div class="mat-cell" style="text-align:center;overflow:visible !important;"><mat-icon style="height:24px;width:24px;overflow:visible !important;"><ng-container *ngTemplateOutlet="checkCircleIcon">
        </ng-container></mat-icon></div>
      </div>
    </div>
  </div>
  <div modal-footer class="row">
    <div class="col-12">
      <button style="min-width:100%;" mat-flat-button color="accent" (click)="onCancelClicked()"><adp-label labelKey="Global_Modal_CellularEnabled_Info_Button_Ok"></adp-label></button>
    </div>
  </div>
  <ng-template #checkCircleIcon>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22 11.0799V11.9999C21.9988 14.1563 21.3005 16.2545 20.0093 17.9817C18.7182 19.7088 16.9033 20.9723 14.8354 21.5838C12.7674 22.1952 10.5573 22.1218 8.53447 21.3744C6.51168 20.6271 4.78465 19.246 3.61096 17.4369C2.43727 15.6279 1.87979 13.4879 2.02168 11.3362C2.16356 9.18443 2.99721 7.13619 4.39828 5.49694C5.79935 3.85768 7.69279 2.71525 9.79619 2.24001C11.8996 1.76477 14.1003 1.9822 16.07 2.85986" stroke="#00CC33" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M22 4L12 14.01L9 11.01" stroke="#00CC33" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </ng-template>
    <ng-template #minusIcon>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 12H19" stroke="#B90000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      </ng-template>
</pgh-modal-window>
